module.exports = __webpack_public_path__ + "static/media/nmTemplate.ef4ac764.xlsx";